import React from 'react';
import { Button, notification, Form, type FormProps, Input, Card,  Upload } from 'antd';
import { CouponService } from "./../../services/CouponService";
import {
    UploadOutlined
} from "@ant-design/icons";
import { Link } from 'react-router-dom';
// import 'ckeditor5/ckeditor5.css';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import { ClassicEditor, Essentials, Paragraph, Bold, Italic, List } from 'ckeditor5';


interface Props {
    record: any
    onFinish: () => void
}

export default function UploadCouponCode(props: Props) {

    const [form] = Form.useForm();
    const [file, setFile] = React.useState<any>();

    const handleFileChange = (info: any) => {
        const uploadedFile = info.file;
        setFile(uploadedFile);
    };

    React.useEffect(() => {
        form.resetFields();

    }, [])


    const onFinish: FormProps["onFinish"] = async (values) => {

        const formData = new FormData();
        formData.append('coupon_id', props?.record?.coupon?.id)
        formData.append('codes', file)
        var res = await CouponService.uploadCouponCode(formData)

        if (res?.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <Card
            title={'Upload Coupon Codes'}
            bordered={false}>

            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    code: '',
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >



                <Form.Item
                    label="Download Template"
                    name="codes"
                >
                    <Link
                        to={`${process.env.REACT_APP_API_URL}/public/shared/templates/Template_Codes.csv`}
                        target="_blank">
                        <Button type='dashed'>Download Csv</Button>
                    </Link>

                </Form.Item>


                <Form.Item
                    label="Upload Csv"
                    name="codes"
                >
                    <Upload
                        beforeUpload={() => false} // Prevent auto upload
                        onChange={handleFileChange}
                        maxCount={1}
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    >
                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                </Form.Item>





                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        อัพโหลด
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
